export const CHEAPER_OPTION_ACTIONS = {
  // ACTIONS SEND
  SEND_CHEAPER_OPTION: 'CHEAPER_OPTION:SEND_CHEAPER_OPTION',
  SEND_CHEAPER_OPTION_SUCCESS: 'CHEAPER_OPTION:SEND_CHEAPER_OPTION_SUCCESS',
  SEND_CHEAPER_OPTION_ERROR: 'CHEAPER_OPTION:SEND_CHEAPER_OPTION_ERROR',
  // FETCH SEND
  FETCH_CHEAPER_OPTION_TEXTS_SUCCESS: 'CHEAPER_OPTION:FETCH_CHEAPER_OPTION_TEXTS_SUCCESS',
};
